/**
 * CLE-2654 — cleans the health-system names typed into the hospital form so the chips shown match
 * what the save will actually store.
 *
 * The API applies the same rule before writing the column, and it stays the authority. Without a
 * copy here the form silently disagrees with itself: typing "Huntsville Hospital" and then
 * "HUNTSVILLE HOSPITAL" leaves two chips on screen, and after saving and reloading one has
 * disappeared with no explanation.
 *
 * Keep this in step with `normaliseBenefitNameSynonyms` in
 * services/clear-api/src/domains/accounts/accounts.helpers.ts. The two are deliberately duplicated
 * rather than shared — the SPA and the API do not share a module — so a change to one needs the
 * other. Both are covered by tests that spell out the same cases.
 *
 * Case is preserved because it is shown back to whoever typed it. De-duplication ignores case
 * because the matching that consumes this list ignores case, so two spellings are one rule.
 * Nothing splits on commas: payer wording routinely contains them inside a single name.
 */
export const normaliseBenefitNameSynonyms = (synonyms: string[]): string[] => {
  const seen = new Set<string>();

  return synonyms
    .map((synonym) => synonym.trim())
    .filter((synonym) => {
      if (!synonym) return false;
      const key = synonym.toUpperCase();
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
};
